<h2 mat-dialog-title>{{ isExisting ? "Edit" : "Add" }} Task</h2>
<div mat-dialog-content>
  <form class="task-form">
    <div class="row gutters">
      <mat-form-field class="col-md-6">
        <mat-label>Task</mat-label>
        <input type="text" matInput [formControl]="formGroup.controls.task" />
      </mat-form-field>
      <mat-form-field class="col-md-6">
        <mat-label>Status</mat-label>
        <mat-select
          [formControl]="formGroup.controls.consent_checklist_status_id">
          @for (
            status of checklistService.consentChecklistStatuses$ | async
            ; track
            status) {
            <mat-option
              [value]="status.id"
              >{{ status.checklist_status }}</mat-option
              >
            }
          </mat-select>
        </mat-form-field>
      </div>
      <div class="row gutters">
        <mat-form-field class="col-md-6">
          <mat-label>Responsible Party</mat-label>
          <mat-select [formControl]="formGroup.controls.group_id">
            <mat-option>&mdash;</mat-option>
            @for (group of checklistService.groups$ | async; track group) {
              <mat-option
                [value]="group.id"
                >{{ group.name }}</mat-option
                >
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field class="col-md-6">
            <mat-label>Days to complete</mat-label>
            <input
              type="number"
              class="days"
              min="0"
              matInput
              [formControl]="formGroup.controls.days_to_complete" />
            @if (formGroup.controls.days_to_complete.value === null) {
              <mat-icon
                matTooltip="This number (if set) will be used to calculate an automatic due date when the task is set to In Progress."
                matIconSuffix
                >help</mat-icon
                >
              }
            </mat-form-field>
          </div>
          <div class="row gutters">
            <mat-form-field class="col-md-6">
              <mat-label>Start Date</mat-label>
              <input
                matInput
                [matDatepicker]="startDatePicker"
                [formControl]="formGroup.controls.start_date" />
              <mat-datepicker-toggle
                matIconSuffix
              [for]="startDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #startDatePicker></mat-datepicker>
            </mat-form-field>
            <mat-form-field class="col-md-6">
              <mat-label>Due Date</mat-label>
              <input
                matInput
                [matDatepicker]="dueDatePicker"
                [formControl]="formGroup.controls.due_date" />
              <mat-datepicker-toggle
                matIconSuffix
              [for]="dueDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #dueDatePicker></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="row gutters">
            <mat-form-field>
              <mat-label>Notes</mat-label>
              <textarea
                [formControl]="formGroup.controls.checklist_notes"
                matInput
                cdkTextareaAutosize
                style="resize: none">
              </textarea>
            </mat-form-field>
          </div>
        </form>
      </div>
      <div mat-dialog-actions>
        <button
          mat-raised-button
          [disabled]="!!(checklistService.tasksLoading$ | async)"
          (click)="dialogRef.close()">
          Cancel
        </button>
        <button
          mat-raised-button
          [disabled]="!!(checklistService.tasksLoading$ | async)"
          color="primary"
          (click)="saveForm()">
          Save
        </button>
      </div>
